import BadgeNew from './BadgeNew';

export default BadgeNew;

export { BadgeNew };
